// extracted by mini-css-extract-plugin
export default {"wrapper":"pageChangeViewer_wrapper__27dol","cssSelector":"pageChangeViewer_cssSelector__TNH07"};